/* eslint-disable */
import {NavigationBlock} from './NavigationBlock';
/**
* @description Interface for Avensia.Commerce.Web.src.components.MainMenu.themes.BGH_RD3.mobile.customerPages.HelpCenterNavigationBlock
*/
export interface HelpCenterNavigationBlock extends NavigationBlock {
	
}
export const isHelpCenterNavigationBlock = (model: unknown): model is HelpCenterNavigationBlock => (model as HelpCenterNavigationBlock).component === 'Bygghemma.Commerce.Web.src.components.MainMenu.themes.BGH_RD3.mobile.customerPages.HelpCenterNavigationBlock';

